import Vue from 'vue'
import Vuex from 'vuex'
// #ifdef H5
import VuexPersist from 'vuex-persist'
// #endif


Vue.use(Vuex)

// #ifdef H5
const vuexPersist = new VuexPersist({
  key: 'my-app',
  storage: window.localStorage
})
// #endif
const store = new Vuex.Store({
  state: {
    // 用户信息
    user: {},
  },
  mutations: {
    // 修改用户信息
    changeUser(state, payload) {
      state.user = payload.data;
    }
  },
  actions: {},
  // #ifdef H5
  plugins: [vuexPersist.plugin]
  // #endif
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js